export const LIST = "REWARD_ITEM_LIST";
export const DROPDOWN = "REWARD_ITEM_DROPDOWN";
export const DETAILS = "REWARD_ITEM_DETAILS";
export const STORE = "REWARD_ITEM_STORE";
export const UPDATE = "REWARD_ITEM_UPDATE";
export const UPDATE_STATUS = "REWARD_ITEM_UPDATE_STATUS";
export const HISTORY = "REWARD_ITEM_HISTORY";
export const HISTORY_DETAILS = "REWARD_ITEM_HISTORY_DETAILS"; 
export const HISTORY_UPDATE = "REWARD_ITEM_HISTORY_UPDATE";
export const HISTORY_REFUND = "REWARD_ITEM_HISTORY_REFUND";